export default "__VITE_ASSET__BXhl2SwE__"